import React, { useState, useEffect, useRef } from "react";
import { storeLocation } from "../utils/constants";
import useApis from "../services/useAPI";
import { useNavigate } from "react-router";
import { Spinner } from "react-bootstrap";
import { removeLeadingZeros } from "../utils/utils";

const StoreLocation = () => {
  const [storeNumber, setStoreNumber] = useState("");
  const {
    callApi,
    serverError,
    isLoading,
    setIsLoading,
    resultGet,
    setServerError,
    setResultGet,
  } = useApis(storeLocation, "GET");
  const [hasSearched, setHasSearched] = useState(false);
  const navigate = useNavigate();
  const storeNumberInputRef = useRef(null);
  const selectedService = localStorage.getItem("selectedService");
  useEffect(() => {
    setIsLoading(false);
    storeNumberInputRef.current?.focus();
  }, []);

  const handleContinue = (store) => {
    sessionStorage.setItem("selectedStore", JSON.stringify(store));

    navigate("/patient-record");
  };

  const handleChange = (e) => {
    const value = e.target.value;

    if (/^[a-zA-Z0-9]*$/.test(value)) {
      setStoreNumber(value);

      setHasSearched(false);
      setServerError(null);
      setResultGet([]);
    }
  };

  const handleSearch = async () => {
    const value = storeNumber.trim();
    const trimmedStore = removeLeadingZeros(value);

    if (value.length < 4) return;
    if (isLoading) return;

    setHasSearched(true);

    const searchValue =
      trimmedStore !== value ? `${value},${trimmedStore}` : value;

    await callApi(searchValue, `${storeLocation}${value}`, "GET");
  };

  if (!serverError && isLoading)
    return (
      <div className="text-center">
        <Spinner
          animation="border"
          variant="info"
          className="my-custom-spinner mt-5"
        />
      </div>
    );

  return (
    <div className="store-location-page">
      <div className="store-location-card">
        <div className="form-group">
          {selectedService === "clinical" ? (
            
              <label htmlFor="storeNumber">
                Site/Store search
                <p>
                  Please enter 4 character site id/store number. Click{" "}
                  <b>‘Search’</b> to continue.
                </p>
              </label>
            
          ) : (
            
              <label htmlFor="storeNumber">
                Store search
                <p>
                  Please enter the 4 digit store number. Click <b>‘Search’</b> to
                  continue.
                </p>
              </label>
            
          )}
          <div className="search-input-group">
            <input
              ref={storeNumberInputRef}
              id="storeNumber"
              type="text"
              placeholder={
                selectedService === "clinical" ? "e. g., AB21" : "e. g., 0021"
              }
              value={storeNumber}
              maxLength={10}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !isLoading) {
                  handleSearch();
                }
              }}
            />
            <button onClick={handleSearch}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 3C15.4183 3 19 6.58172 19 11C19 12.8486 18.3703 14.5487 17.3174 15.9033L21.207 19.793L19.793 21.207L15.9033 17.3174C14.5487 18.3703 12.8486 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3ZM11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17C14.3137 17 17 14.3137 17 11C17 7.68629 14.3137 5 11 5Z"
                  fill="white"
                />
              </svg>
              <span>Search</span>
            </button>
          </div>
          <hr />
          {/* {!hasSearched &&
            (selectedService === "clinical" ? (
              <small>
                Enter a minimum 4 characters site number.
              </small>
            ) : (
              <small>
                Enter a minimum 4-digit store Id.
              </small>
            ))} */}

          {/* Loading State */}
          {hasSearched && isLoading && (
            <div className="store-loading">Searching store...</div>
          )}

          {/* Results State */}
          {hasSearched && !isLoading && resultGet?.length > 0 && (
            <div className="store-results">
              <h2>Search result</h2>
              <p className="boots-help-text">
                Please confirm the store details displayed below is the one you
                are looking for.<br /> If yes, please click <b>‘Continue’</b>.
                <br />
                If no, please re-enter the store number and search again.
              </p>
              {resultGet.map((store) => (
                <div
                  key={store.id}
                  className="store-result-card d-flex justify-content-between"
                >
                  <div className="store-result-card__content">
                    <div className="store-result-card__title">
                      {store.store_name} - {store.store_number}
                    </div>

                    <div className="store-result-card__address">
                      <p>{store.area}</p>
                      <p>{store.region}</p>
                      {store.address.split(",").map((line) => {
                        const addressLine = line.trim();
                        return <p key={addressLine}>{addressLine}</p>;
                      })}
                    </div>
                  </div>
                  <div className="store-result-card__actions">
                    <button
                      className="continue-btn"
                      onClick={() => handleContinue(store)}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* No Results State */}
          {hasSearched && !isLoading && resultGet?.length === 0 && (
            <div className="store-error">
              <svg width="20" height="20" viewBox="0 0 24 24"></svg>

              {serverError ? (
                <span>{serverError}</span>
              ) : selectedService === "clinical" ? (
                <span>
                  No matching site found. Please check the site id/store number and try again.
                </span>
              ) : (
                <span>
                  No matching store found. Please check the store number and try again.
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoreLocation;
